/**
 * Fiche produit : regroupe le hero + les sections Duo consécutives
 * dans un wrapper (hero | aside). Le sticky s'arrête au premier non-Duo.
 * L'aside garde la hauteur de son contenu (pas 100vh).
 * Sync scroll : calques lifestyle du hero ↔ sections droites.
 */
(function () {
  const MAIN_ID = 'MainContent';
  const WRAPPER_CLASS = 'product-layout-duo';
  const ASIDE_CLASS = 'product-layout-duo__aside';
  const DUO_CLASS = 'product-layout--duo';
  const HERO_CLASS = 'section-product-hero';
  const SCENE_ORDER = ['buy', 'assemblage', 'degustation', 'accords'];
  const DESKTOP_MQ = '(min-width: 990px)';

  let sceneCleanup = null;

  function markDuoSections(root) {
    root.querySelectorAll('[data-product-duo]').forEach((el) => {
      const section = el.closest('.shopify-section');
      if (!section) return;

      if (el.getAttribute('data-product-duo') === 'true') {
        section.classList.add(DUO_CLASS);
      } else {
        section.classList.remove(DUO_CLASS);
      }
    });
  }

  function unwrapExisting(main) {
    main.querySelectorAll('.' + WRAPPER_CLASS).forEach((wrapper) => {
      const parent = wrapper.parentNode;
      if (!parent) return;

      const nodes = [];

      Array.from(wrapper.children).forEach((child) => {
        if (child.classList.contains(ASIDE_CLASS)) {
          Array.from(child.children).forEach((section) => nodes.push(section));
        } else {
          nodes.push(child);
        }
      });

      nodes.forEach((node) => parent.insertBefore(node, wrapper));
      wrapper.remove();
    });
  }

  function wrapDuoZone(main) {
    const hero = main.querySelector(':scope > .' + HERO_CLASS);
    if (!hero) return;

    const siblings = Array.from(main.children);
    const heroIndex = siblings.indexOf(hero);
    if (heroIndex === -1) return;

    const duoSections = [];

    for (let i = heroIndex + 1; i < siblings.length; i++) {
      const section = siblings[i];
      if (section.classList.contains(DUO_CLASS)) {
        duoSections.push(section);
      } else {
        break;
      }
    }

    if (duoSections.length === 0) return;

    const wrapper = document.createElement('div');
    wrapper.className = WRAPPER_CLASS;

    const aside = document.createElement('div');
    aside.className = ASIDE_CLASS;

    main.insertBefore(wrapper, hero);
    wrapper.appendChild(hero);
    duoSections.forEach((section) => aside.appendChild(section));
    wrapper.appendChild(aside);
  }

  function resolveScene(requested, available) {
    if (available.has(requested)) return requested;
    const idx = SCENE_ORDER.indexOf(requested);
    if (idx === -1) return 'buy';
    for (let i = idx - 1; i >= 0; i--) {
      if (available.has(SCENE_ORDER[i])) return SCENE_ORDER[i];
    }
    return 'buy';
  }

  function initHeroScenes(main) {
    if (typeof sceneCleanup === 'function') {
      sceneCleanup();
      sceneCleanup = null;
    }

    const hero = main.querySelector('[data-product-hero][data-hero-scenes]');
    if (!hero) return;

    const sceneEls = Array.from(hero.querySelectorAll('.product-hero__scene[data-hero-scene]'));
    if (sceneEls.length < 2) return;

    const available = new Set(sceneEls.map((el) => el.getAttribute('data-hero-scene')));
    const triggers = Array.from(
      main.querySelectorAll('.product-layout-duo__aside [data-hero-scene]')
    );
    if (!triggers.length) return;

    const mq = window.matchMedia(DESKTOP_MQ);
    let current = 'buy';
    let ticking = false;

    const setScene = (scene) => {
      const next = resolveScene(scene, available);
      if (next === current && hero.getAttribute('data-active-scene') === next) return;
      current = next;
      hero.setAttribute('data-active-scene', next);
      sceneEls.forEach((el) => {
        el.classList.toggle('is-active', el.getAttribute('data-hero-scene') === next);
      });
    };

    const updateFromScroll = () => {
      if (!mq.matches) {
        setScene('buy');
        return;
      }

      const heroRect = hero.getBoundingClientRect();
      const viewH = window.innerHeight;
      const viewMid = viewH * 0.5;

      // Packshot forcé au début → retarde l'entrée d'assemblage
      const enterDelay = heroRect.height * 0.28;
      if (window.scrollY < enterDelay) {
        setScene('buy');
        return;
      }

      let active = 'buy';
      let lastLifestyle = null;

      for (let i = 0; i < triggers.length; i++) {
        const scene = triggers[i].getAttribute('data-hero-scene') || 'buy';
        const rect = triggers[i].getBoundingClientRect();

        if (scene === 'assemblage') {
          // ~20% de la section a dépassé le milieu de l'écran
          const point20 = rect.top + rect.height * 0.2;
          if (point20 <= viewMid) {
            active = scene;
            lastLifestyle = scene;
          }
        } else if (scene === 'degustation') {
          // Début de section passé le milieu de l'écran
          if (rect.top <= viewMid) {
            active = scene;
            lastLifestyle = scene;
          }
        } else if (scene === 'accords') {
          // Bas visible, ou section déjà entièrement passée au-dessus
          if (rect.top < viewH && rect.bottom <= viewH) {
            active = scene;
            lastLifestyle = scene;
          }
        } else if (rect.top <= viewMid) {
          // buy
          active = scene;
        }
      }

      // Fin de sticky / bas de page : ne pas retomber sur le packshot
      const duo = hero.closest('.' + WRAPPER_CLASS);
      if (duo) {
        const duoBottom = duo.getBoundingClientRect().bottom;
        if (duoBottom <= heroRect.bottom + 4 && active === 'buy' && lastLifestyle) {
          active = lastLifestyle;
        } else if (duoBottom <= heroRect.bottom + 4 && active === 'buy' && current !== 'buy') {
          active = current;
        }
      }

      setScene(active);
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        updateFromScroll();
      });
    };

    const onMqChange = () => {
      updateFromScroll();
    };

    setScene('buy');
    updateFromScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onMqChange);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(onMqChange);
    }

    sceneCleanup = () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (typeof mq.removeEventListener === 'function') {
        mq.removeEventListener('change', onMqChange);
      } else if (typeof mq.removeListener === 'function') {
        mq.removeListener(onMqChange);
      }
    };
  }

  function initProductLayout() {
    const main = document.getElementById(MAIN_ID);
    if (!main || !document.body.classList.contains('template-product')) return;

    markDuoSections(main);
    unwrapExisting(main);
    wrapDuoZone(main);
    initHeroScenes(main);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductLayout);
  } else {
    initProductLayout();
  }

  document.addEventListener('shopify:section:load', initProductLayout);
  document.addEventListener('shopify:section:unload', initProductLayout);
  document.addEventListener('shopify:section:reorder', initProductLayout);
})();
